import { Injectable } from '@angular/core';
import { Client } from './client';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HistoryService {

  constructor ( private client: Client, private http: HttpClient ) { }

  getHistoryOrder ( obj ) {
    return this.http.get( this.client.getHistoryOrderUrl( obj ) );
  }

  getHistoryDriver ( obj ) {
    return this.http.get( this.client.getHistoryDriverUrl( obj ) );
  }

  getHistoryCauser ( obj ) {
    return this.http.get( this.client.getHistoryCauserUrl( obj ) );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/history.service.ts